import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { ComingSoon } from './pages/ComingSoon';
import { getAllPages } from './utils/navigation';
const pages = getAllPages();
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbt2ovkq6938">
      <Routes data-id="element-1" data-mp="3fb9it9bilamk">
        <Route element={<Layout data-id="element-3" data-mp="2rkx5fixi2lol" />} data-id="element-2" data-mp="3f8nd7f86p56z">
          <Route path="/" element={<Home data-id="element-5" data-mp="2rlp1euv0elfe" />} data-id="element-4" data-mp="2rkdsyhqmcphy" />
          <Route path="/accueil" element={<Home data-id="element-7" data-mp="2mlu68f47b9oj" />} data-id="element-6" data-mp="2rl6u936t6msp" />
          {pages.map(({
          page,
          group
        }) => <Route key={page.path} path={page.path} element={<ComingSoon page={page} group={group} data-id="element-9" data-mp="31b8lg3ugklbu" />} data-id="element-8" data-mp="2mnnefyugq1yn" />)}
          <Route path="*" element={<ComingSoon page={{
          label: 'Page introuvable',
          path: '*',
          description: "Cette page n'existe pas encore."
        }} data-id="element-11" data-mp="2wiywor52xrb5" />} data-id="element-10" data-mp="31cjp83nwlt2y" />
        </Route>
      </Routes>
    </BrowserRouter>;
}